import { Axios } from '../../axios';

const getNSITF = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : '';

  const { data } = await Axios.get(
    `/statutory-payments/nsitf?limit=${payload.limit}&page=${payload.page}${search}`,
  );

  return data?.data;
};

const bulkNSITF = async (payload) => {
  const { data } = await Axios.post('/statutory-payments/nsitf/bulk', payload);
  return data;
};

const fetchNSITFByRef = async (payload) => {
  let search = payload.search ? '&search=' + payload.search : '';
  const { data } = await Axios.get(`/statutory-payments/nsitf/by-ref/${payload.refId}?limit=${payload.limit}&page=${payload.page}${search}`);
  if (data?.data) {
    data.data.nsitf.total_amount = data?.data.total_amount
    data.data.nsitf.total_payable = data?.data.total_payable
    data.data.nsitf.total_trans_cost = data?.data.total_fees
  }
  return data?.data.nsitf;
};

export const nsitfApis = {
    getNSITF,
    bulkNSITF,
    fetchNSITFByRef
};